import { Modal, notification, TextInput } from "components/common";
import TextEditor from "components/common/textEditor/textEditor";
import { useAddFeedbackMutation } from "features/script/api";
import { useState } from "react";

const FeedbackModal = ({ feedbackVisible, setFeedbackVisible }) => {
  const [feedbackData, setFeedbackData] = useState({
    title: "",
    description: "",
  });

  const [addFeedback, { isLoading: feedbackLoading }] =
    useAddFeedbackMutation();

  const handleAddFeedback = async () => {
    const res = await addFeedback({});
    if (res?.error) {
      notification.error({ message: res?.error?.message });
    } else {
      notification.success("Feedback Added Successfully!");
    }
  };
  return (
    <Modal
      visible={feedbackVisible}
      setVisible={setFeedbackVisible}
      title={"Add Feedback"}
      okText={"Submit"}
      onOk={handleAddFeedback}
      onCancel={() => setFeedbackVisible(false)}
    >
      <div>
        <TextInput
          placeholder={"Add Title"}
          value={feedbackData?.title}
          onChange={(e) =>
            setFeedbackData((prev) => ({ ...prev, title: e?.target?.value }))
          }
          style={{ marginBottom: "15px" }}
        />
        <TextEditor
          style={{ textAlign: "left" }}
          key={"DescriptionFeedback"}
          value={feedbackData?.description}
          onChange={(e) =>
            setFeedbackData((prev) => ({ ...prev, description: e }))
          }
          placeholder={"Add description"}
          toolbarVisible={true}
          editorHeight={200}
        />
      </div>
    </Modal>
  );
};

export default FeedbackModal;
